<template>
  <v-layout row xs12>
    <Loading :value="loading"></Loading>
    <v-dialog v-model="dialogAjoutConducteur" max-width="100%">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Ajouter des lots de taches </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout row>
            <v-flex xs12>
              <data-tables :data="listeTypeTravaux" style="width: 100%">
                <el-table-column prop="ordre" label="Ordre" width="300">
                  <template slot-scope="scope">
                    <v-chip label text-color="white" color="primary">
                      {{ scope.row.ordre }}
                    </v-chip>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="libelle"
                  label="Libellé tâche"
                  width="300"
                >
                  <template slot-scope="scope">
                    <v-chip label text-color="white" color="primary">
                      {{ scope.row.libelle }}
                    </v-chip>
                  </template>
                </el-table-column>
                <el-table-column prop="unite" label="Unité" width="200">
                  <template slot-scope="scope">
                    <v-chip label text-color="white" color="primary">
                      {{ scope.row.unite }}
                    </v-chip>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="prix"
                  label="Prix unitaire (FCFA)"
                  width="200"
                >
                  <template slot-scope="scope">
                    <v-chip label text-color="white" color="primary">
                      {{
                        new Intl.NumberFormat("fr-FR").format(scope.row.prix)
                      }}
                    </v-chip>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="description"
                  label="Description"
                  width="300"
                >
                  <template slot-scope="scope">
                    <v-chip label text-color="white" color="primary">
                      {{ scope.row.description }}
                    </v-chip>
                  </template>
                </el-table-column>
              </data-tables>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs6>
              <v-tooltip top>
                <v-btn
                  @click="closeDialog()"
                  slot="activator"
                  icons
                  block
                  color="orange"
                  dark
                  >Anuller <v-icon right>remove_circle</v-icon></v-btn
                >
                <!-- <v-btn slot="activator" icons block  @click="closeDialog()" dark>Anuller <v-icon right>remove_circle</v-icon></v-btn> -->
                <span>Annuler</span>
              </v-tooltip>
            </v-flex>

            <v-flex xs6>
              <v-tooltip top>
                <v-btn
                  slot="activator"
                  icons
                  block
                  color="green"
                  @click="saveListe()"
                  dark
                  >Enregistrer <v-icon right>save</v-icon></v-btn
                >
                <span>Enregistrer les lots de taches</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Loading from "@/components/Loading";
export default {
  name: "LoadConducteurExcel",
  components: { Loading },
  props: {
    listeTypeTravaux: {
      type: Array,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    idTypeTravaux: {
      type: Number
    }
  },
  data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      dialogAjoutConducteur: false,
      loading: false
    };
  },
  watch: {
    show: function(newValue, oldValue) {
      if (newValue == true) {
        this.dialogAjoutConducteur = true;
      } else {
        this.dialogAjoutConducteur = false;
      }
    }
  },
  methods: {
    saveListe() {
      let succesEnreg = true;
      let url = this.domaine + "projet/save/liste_Taches/excel";
      let nbData = 10;
      let nbReq = 1;
      let ligne = null;

      let nbRest;

      if (this.listeTypeTravaux.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.listeTypeTravaux.length / nbData);
        nbRest = this.listeTypeTravaux.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }
      for (let i = 0; i < nbReq; i++) {
        let initJ = i * nbData;
        let finJ = (i + 1) * nbData;
        let dataLot = [];
        if (this.listeTypeTravaux.length > 0) {
          for (let j = initJ; j < finJ; j++) {
            if (this.listeTypeTravaux[j] == undefined) {
              break;
            }
            dataLot.push(this.listeTypeTravaux[j]);
          }
        }
        let data = new FormData();
        // data.append('listeTypeTravaux', JSON.stringify(dataLot))
        for (let prop in dataLot) {
          ligne = dataLot[prop];
          data.append("option[ordre][]", ligne.ordre);
          data.append("option[libelle][]", ligne.libelle);
          data.append("option[unite][]", ligne.unite);
          data.append("option[valeur][]", ligne.prix);
          data.append("option[description][]", ligne.description);
        }

        data.append("idTypeTache", this.idTypeTravaux);
        data.append("idUser", this.user.id);

        this.$http.post(url, data).then(
          resp => {},
          error => {
            this.loading = false;
            this.$message.error(
              "Erreur lors de l'enregistrement des types travaux"
            );
            succesEnreg = false;
            window.location.reload();
          }
        );
      }
      const loading = this.$loading({
        lock: true,
        text: "Veuillez patientez ...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(() => {
        loading.close();
        // this.loading = false
        this.dialogAjoutConducteur = false;
        if (succesEnreg == true) {
          this.$notify({
            title: "Enregistrement",
            message: "La liste a ete enregistre avec succes",
            type: "success",
            position: "top-right",
            duration: 7000
          });
          this.$emit("close");
        }
      }, 30000);
    },
    loadTache() {
      let url = "";
      if (this.droitAcces.index_tache_type) {
        url = this.domaine + "projet/index/tache/type";
      } else {
        url = this.domaine + "projet/index/" + this.user.id + "/tache/type";
      }
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listTache = response.body.tache;
          this.listeRapportTrx = response.body.tache;
          this.itemsTaches = response.body.tache;
        }
      });
    },
    closeDialog() {
      const loading = this.$loading({
        lock: true,
        text: "Veuillez patientez ...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(() => {
        loading.close();
        this.$emit("close");
      }, 1000);
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/divers/loadTypeTaches.vue